export const profile = {
  name: 'Eric Soults',
  title: 'PMO Chief · Enterprise Transformation Leader · Senior Executive Leader, Iowa Army National Guard',
  location: 'Grimes, Iowa, United States',
  linkedin: 'https://linkedin.com/in/ericsoults-7224b41a',
  linkedinLabel: 'linkedin.com/in/ericsoults-7224b41a',
  email: 'esoults@gmail.com',
  phone: '312-498-7191',
  phoneHref: 'tel:+13124987191',
  portrait: 'https://cdn.magicpatterns.com/uploads/wiehA5tvD4Xi16hTVYGA1a/ERIC.jpg',
  headline: [
    'Enterprise Transformation',
    'Strategic Leadership',
    'Operational Excellence',
  ],
  subheadline:
    'PMO Chief & Military Leader. 20+ years of governance, technology modernization, and mission-critical execution across defense, government, and corporate sectors.',
  badges: ['PMP Certified', 'MS Strategic Studies', 'US Army Senior Executive Leader'],
}

export const stats = [
  { value: '20+ Years', label: 'Enterprise Leadership Experience' },
  { value: '4,000+', label: 'Personnel Led in Command' },
  { value: 'Enterprise PMO', label: 'USDA Regulatory & Tech Modernization' },
  { value: 'PMP®', label: 'Certified Project Management Professional' },
]

export type Competency = {
  icon:
    | 'governance'
    | 'command'
    | 'transformation'
    | 'compliance'
    | 'technology'
    | 'operations'
  title: string
  description: string
}

export const competencies: Competency[] = [
  {
    icon: 'governance',
    title: 'Enterprise PMO & Portfolio Governance',
    description: 'USDA APHIS modernizations. Multi-million dollar portfolios.',
  },
  {
    icon: 'command',
    title: 'Military & Strategic Command',
    description:
      'Iowa Army National Guard Senior Executive Leader. Domestic and international operations.',
  },
  {
    icon: 'transformation',
    title: 'Change Delivery & Business Transformation',
    description: 'Mercer US & Canada. Cross-functional organizational alignment.',
  },
  {
    icon: 'compliance',
    title: 'Regulatory Compliance & Risk Management',
    description: 'GDPR, CCPA, and federal regulatory frameworks.',
  },
  {
    icon: 'technology',
    title: 'Technology & Systems Modernization',
    description: 'Information Systems MS. IT infrastructure and digital workflows.',
  },
  {
    icon: 'operations',
    title: 'Executive Operations & Business Growth',
    description: 'Heartland Family Eyecare. Operational growth and financial governance.',
  },
]

export type CareerEntry = {
  organization: string
  role: string
  period: string
  impact: string[]
}

export const career: CareerEntry[] = [
  {
    organization: 'USDA APHIS',
    role: 'PMO Chief',
    period: 'March 2024 – Present',
    impact: [
      'Directing enterprise IT programs for nationwide regulatory operations.',
    ],
  },
  {
    organization: 'Army National Guard',
    role: 'Military Officer / Senior Executive Leader',
    period: 'March 2004 – Present',
    impact: [
      'Leading a 4,251-member military organization.',
      'Strategic readiness and international mission execution.',
    ],
  },
  {
    organization: 'Mercer',
    role: 'Change Delivery Manager',
    period: '2013 – 2024',
    impact: [
      'Enterprise transformation, governance, and compliance across US & Canada.',
    ],
  },
  {
    organization: 'Northrop Grumman / GDIT / CSC',
    role: 'Site Task Lead & Operations Manager',
    period: 'Federal Contracts',
    impact: [
      'Federal contract execution.',
      'Defense operational training and team leadership.',
    ],
  },
  {
    organization: 'US Army',
    role: 'Active Duty Officer',
    period: '2000 – 2004',
    impact: ['Command and staff assignments.'],
  },
]

export const education = [
  {
    degree: 'M.S. Military Strategic Studies',
    institution: 'The United States Army War College',
  },
  {
    degree: 'M.S. Information Systems Management',
    institution: 'University of Phoenix',
  },
  {
    degree: 'B.S. Management Information Systems',
    institution: 'Iowa State University',
  },
]

export const certifications = [
  {
    degree: 'Project Management Professional (PMP)®',
    institution: 'Project Management Institute',
  },
  { degree: 'Military Command & Staff Officer Training', institution: 'US Army' },
]
